import type { TFunction } from 'i18next'
import * as React from 'react'
import type { PopupButtonColor } from 'zaptic-popup-button'

interface Action {
    onClick: () => void
    label: string
    color?: PopupButtonColor
}
interface Props {
    i18n: TFunction
    actions: Action[]
}

export const NoMatchesModal = ({ i18n, actions }: Props) => {
    const errorHeading = i18n('appcore:NoMatchesModal.heading')
    const message = i18n('appcore:NoMatchesModal.message')

    return (
        <zaptic-modal z-index={4}>
            <zaptic-full-page-message image="icons-messages-no-results.svg" heading={errorHeading}>
                <div>{message}</div>
                <zaptic-spacer vertical-spacing={30}></zaptic-spacer>
                {actions.map((action, idx) => (
                    <zaptic-popup-button key={idx} color={action.color} onClick={action.onClick}>
                        {action.label}
                    </zaptic-popup-button>
                ))}
            </zaptic-full-page-message>
        </zaptic-modal>
    )
}
